import './Divider.css';

import type { FunctionComponent } from 'react';

export const Divider: FunctionComponent = () => <div className="divider" />;
